import React from "react";
import { Row, Col } from "antd";
import "./Features.scss";
import {
  CardIntegration,
  InstantSwapping,
  SecureCompliant,
  MultiCurrSupport,
  CrossBorderPayment,
  GlobalEban,
  EasyCurrency,
  AdvanceTrading,
} from "../../assets/StoreAsset/StoreAssets";
function Features() {
  const data = [
    {
      id: 1,
      img: <CardIntegration />,
      title: "Crypto-Card Integration",
      detail:
        "Spend your crypto with UWPS-linked card, with real-time conversion for quick global payments.",
    },
    {
      id: 2,
      img: <InstantSwapping />,
      title: "Instant Swapping",
      detail:
        "Swap crypto within your wallet using liquidity aggregation for optimized rates.",
    },
    {
      id: 3,
      img: <MultiCurrSupport />,
      title: "Multi-currency Support",
      detail:
        "Transact in a wide range of fiat and crypto currencies, including USD, EUR, BTC, ETH, BNB, and more.",
    },
    {
      id: 4,
      img: <SecureCompliant />,
      title: "Secure and Compliant",
      detail:
        "Keep your assets safe with platform supported KYC verification, AML checks, and smart contract audits.",
    },
    {
      id: 5,
      img: <CrossBorderPayment />,
      title: "Cross-Border Payments",
      detail:
        "Send global transactions with minimal fees using blockchain powered smart contracts.",
    }, {
      id: 6,
      img: <EasyCurrency />,
      title: "Easy Currency Conversion",
      detail:
        "Get the best exchange rates for crypto-fiat transactions with AI-enabled rate optimization. ",
    }, {
      id: 7,
      img: <GlobalEban />,
      title: "Global IBANs",
      detail:
        "Receive salaries, pay bills, and conduct SEPA/SWIFT transactions via your IBAN-connected wallets.",
    }, {
      id: 8,
      img: <AdvanceTrading />,
      title: "Advanced Trading",
      detail:
        "Execute high-frequency trades with top-notch tools, real-time market analytics, and AI-driven execution.",
    },
  ];
  return (
    <div className="features" id='feature'>
      <h4 className="features_topText">FEATURES</h4>
      <h2 className="features_crafting">CRAFTING<span> FINANCIAL </span> <span>EXCELLENCE</span> </h2>
      <p className="features_text">Every feature of UniWallet Pay is an interdependent variable, contributing to a greater whole - <br />sophisticated, seamless, and flexible payment ecosystem.</p>
      <div className="container">
        <Row gutter={[20, 20]}>
          {data?.map((user, id) => (
            <Col xs={24} sm={12} lg={8} xl={6} key={id}>
              <div className="features_inner inner">
                <div className="features_inner_img divImg"> {user.img}</div>
                <h4>{user.title}</h4>
                <p>{user.detail}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default Features;
